"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateGenericSports = exports.groupEventItemsBySport = void 0;
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const _reduxjs_1 = require("../../../utils/@reduxjs");
const groupEventItemsBySport = (events) => (0, mapValues_1.default)((0, groupBy_1.default)(events, (event) => event.tournament.sportId), (events) => (0, _reduxjs_1.toIdsArray)(events));
exports.groupEventItemsBySport = groupEventItemsBySport;
/**
 * TODO: Task PLAT-982, can be used in place with  groupEventItemsBySport after released
 */
const aggregateGenericSports = (eventsBySport, sportsById) => {
    const eventsBySportId = {};
    Object.entries(eventsBySport).forEach(([sportId, events]) => {
        const sport = sportsById[sportId];
        if (sport) {
            const id = sport.genericSportId ? sport.genericSportId : sport.id;
            if (eventsBySportId[id] === undefined) {
                eventsBySportId[id] = [];
            }
            eventsBySportId[id] = [...eventsBySportId[id], ...events];
        }
    });
    return eventsBySportId;
};
exports.aggregateGenericSports = aggregateGenericSports;
//# sourceMappingURL=index.js.map